import { useNavigate, useSearchParams } from 'react-router-dom';
import Button from '../../../components/button/Button';
import { useBrandContext } from '../../../context/BrandContext';

import './SucessRedefinePassword.css';

const SucessRedefinePassword = () => {
  const navigate = useNavigate();

  const brandContext = useBrandContext();

  // A rota forgot-password-app atende dois contextos: o reset pedido dentro do
  // aplicativo nativo e a conta criada por importacao em lote. Nos dois o usuario
  // vive no app, e mandar para o login do webapp desvia ele do lugar certo --
  // ainda mais na importacao, em que ele nem sabia que tinha conta aqui.
  // Quem originou marca com source=nativeapp; sem o parametro, nada muda.
  const [searchParams] = useSearchParams();
  const doAplicativo = searchParams.get('source') === 'nativeapp';

  // So o navegador sabe se estamos num celular, entao a deteccao precisa ser aqui.
  // Mas QUAL loja abrir continua sendo decidido pelo /app/{brand} no CMS, que le os
  // links do proprio cadastro da aplicacao -- assim marca nova funciona sem tocar aqui.
  const ua = navigator.userAgent;
  const android = /android/i.test(ua);
  const ios = /iPhone/i.test(ua);
  const celular = android || ios;

  // O /app/{brand} e do CMS, e o destino tem que ser o appHost da aplicacao
  // (app.spott.eco), onde o backend responde na raiz. Nos hosts que dividem dominio
  // com um React -- webapp.spott.eco, cms.spott.eco -- o backend fica sob /v1, entao
  // montar a URL a partir da API daria um endereco que so funciona naquele host.
  // O appHost vem do cadastro da aplicacao, entao acompanha a marca.
  const appHost = brandContext.brandData?.appHost;
  // /{brand}/app, nao /app/{brand}: so o app desta marca declara esse path no
  // apple-app-site-association. O /app e declarado por 119 aplicacoes, entao no
  // iPhone o link podia ser capturado por outro app instalado, que abria sem fazer
  // nada. Com o path por marca, ou abre o app certo ou vai para a loja certa.
  const linkLoja = `${appHost}/${brandContext.brandName}/app`;

  const mostrarBotaoLoja = doAplicativo && celular && !!appHost;

  return (
    <div className='sucess-switch-password-wrapper'>
      <div className='sucess-switch-password-container'>
        <div className='sucess-switch-password-fields'>
          <span className='sucess-switch-password-title'>
            {doAplicativo ? 'Senha criada' : 'Senha alterada'}
          </span>
          <span className='sucess-switch-password-subtitle'>
            {doAplicativo
              ? 'Tudo pronto. Abra o aplicativo e entre com seu e-mail e a senha que você acabou de criar.'
              : 'Tudo certo para o login no app'}
          </span>

          {mostrarBotaoLoja && (
            <Button
              style={{
                backgroundColor: brandContext.brandBgColor
                  ? brandContext.brandBgColor
                  : '#3CCC10',
                color: '#FFFFFF',
                marginTop: '33px',
              }}
              type='button'
              children={ios ? 'Baixar na App Store' : 'Baixar no Google Play'}
              onClick={() => {
                window.location.href = linkLoja;
              }}
            />
          )}

          {!doAplicativo && (
            <Button
              style={{
                backgroundColor: brandContext.brandBgColor
                  ? brandContext.brandBgColor
                  : '#3CCC10',
                color: '#FFFFFF',
                marginTop: '33px',
              }}
              type='button'
              children='Ir para login'
              onClick={() => navigate(`/${brandContext.brandName}/login`)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SucessRedefinePassword;
